import PropTypes from 'prop-types';

const EnvelopeIcon = ({ className = '' }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <mask
      id="mask0_8461_7562"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="80"
      height="80"
    >
      <path
        d="M80 72V8C80 3.58172 76.4183 4.27116e-08 72 9.53991e-08L7.99999 8.58591e-07C3.58171 9.11279e-07 -7.62939e-06 3.58173 -7.62939e-06 8V72C-7.62939e-06 76.4183 3.58172 80 7.99999 80L72 80C76.4183 80 80 76.4183 80 72Z"
        fill="#FFCCEF"
      />
    </mask>
    <g mask="url(#mask0_8461_7562)">
      <path
        d="M80 72V8C80 3.58172 76.4183 4.27116e-08 72 9.53991e-08L7.99999 8.58591e-07C3.58171 9.11279e-07 -7.62939e-06 3.58173 -7.62939e-06 8V72C-7.62939e-06 76.4183 3.58172 80 7.99999 80L72 80C76.4183 80 80 76.4183 80 72Z"
        fill="#0A0777"
      />
      <path
        d="M-0.0956994 40.1644L-0.0957031 80L79.9993 80L79.9993 40.1644L-0.0956994 40.1644Z"
        fill="white"
      />
      <path
        d="M39.9505 -0.0957041L-0.0969836 40.1637L79.998 40.1637L39.9505 -0.0957041Z"
        fill="#FB6E44"
      />
    </g>
  </svg>
);

EnvelopeIcon.propTypes = {
  className: PropTypes.string
};

export default EnvelopeIcon;
